import { ArraySerializer, Field, Model, Type } from 'serialize-ts';
import { ModelMetadataSerializer } from 'serialize-ts/dist/serializers/model-metadata.serializer';
import { ProductIndexRegion } from './product-index-region.model';
import { ProductIndexPrice } from './product-index-price.model';
import { ProductIndexShipping } from './product-index-shipping.model';
import { ProductIndexUnitPrice } from './product-index-unit-price.model';
import { ProductIndexBasePrice } from './product-index-base-price.model';
import { VolumePrice } from './volume-price.model';

@Model()
export class ProductIndexRegionInfo {
  @Field()
  region: ProductIndexRegion;

  @Field()
  vatRate: string;

  @Field()
  price: ProductIndexPrice;

  @Field()
  msrpPrice: ProductIndexPrice;

  @Field()
  referencePrice: ProductIndexPrice;

  @Field()
  basePrice: ProductIndexBasePrice;

  @Field()
  unitPrice: ProductIndexUnitPrice;

  @Field()
  @Type(new ArraySerializer(new ModelMetadataSerializer(VolumePrice)))
  volumePrices: VolumePrice[];

  @Field()
  shipping: ProductIndexShipping;
}
